function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import { find } from 'lodash';
import Avatar from 'components/Avatar';
import { formatDate } from 'helpers/datetime';
import Button from 'components/Form/Button';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from './VisitCard.pcss';
const HcpProfile = ({ avatar, firstName, lastName, clinicName })=>{
    if (firstName && lastName) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Avatar, {
                    avatarImg: avatar,
                    name: [
                        firstName,
                        lastName
                    ],
                    className: `${styles.avatar} mr-3`,
                    imgClassName: styles.avatar__img,
                    initialsClassName: styles.avatar__initials
                }),
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsxs("h2", {
                            className: "brand__h2",
                            children: [
                                firstName,
                                " ",
                                lastName
                            ]
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "text--small text--light",
                            children: clinicName
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx("h2", {
        className: "brand__h2",
        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.infos.hcpFromClinic), {
            values: {
                clinicName
            }
        }))
    });
};
const VisitDate = ({ visitDate })=>{
    if (!visitDate) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: "text--small text--light ml-auto",
        children: formatDate(visitDate)
    });
};
const VisitActions = ({ phiSetVisit, onShowNotes })=>{
    const associatedNotesBatches = get(phiSetVisit, 'associatedDataIndexKeys.notes', []);
    const replies = get(phiSetVisit, 'replies', 0);
    if (!associatedNotesBatches.length) {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.emptyNotes,
            children: /*#__PURE__*/ _jsx("p", {
                className: "brand__paragraph text--light",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.noNotesToShow))
            })
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        className: styles.showNotes,
        children: /*#__PURE__*/ _jsxs(Button, {
            styleModifier: "primary",
            className: "btn btn--transparent w-100",
            isDisabled: !associatedNotesBatches.length,
            onClick: ()=>onShowNotes(phiSetVisit),
            children: [
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.showNotes)),
                replies ? ` (${replies})` : null
            ]
        })
    });
};
const VisitCard = ({ phiSetVisit, onShowNotes })=>{
    useStyles(styles);
    const { phisetVisitId } = phiSetVisit;
    const visits = useSelector(selectors.visits);
    const visitWithMetadata = find(visits, {
        phisetVisitId: phiSetVisit.phisetVisitId
    });
    if (!visitWithMetadata || !visitWithMetadata.metadata) return null;
    const { createdBy, visitDate } = visitWithMetadata.metadata;
    const { avatar, firstName, lastName, clinicName } = createdBy;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.visidCard,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.visitInfo,
                children: [
                    /*#__PURE__*/ _jsx(HcpProfile, {
                        avatar: avatar,
                        firstName: firstName,
                        lastName: lastName,
                        clinicName: clinicName
                    }),
                    /*#__PURE__*/ _jsx(VisitDate, {
                        visitDate: visitDate
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(VisitActions, {
                phiSetVisit: phiSetVisit,
                onShowNotes: onShowNotes
            })
        ]
    }, phisetVisitId);
};
export default VisitCard;
